module.exports = __webpack_public_path__ + "static/media/a16z.b08f2b99.svg";